var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "payment",
      attrs: { id: "warehouse-registered-payment-method-page" }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "payment-content" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "m-b-xl" }, [
          _vm._v(
            "\n      再度、お申込みになる場合はご利用プランページよりお手続きお願いします。\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flexbox justify-center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-shadow bd-rds-8",
              on: {
                click: function($event) {
                  _vm.$router.push({
                    name: "Setting",
                    params: { tab: "plan-info" }
                  })
                }
              }
            },
            [
              _c("i", {
                staticClass: "fa fa-arrow-circle-right fa-lg mr-r-5",
                attrs: { "aria-hidden": "true" }
              }),
              _vm._v("\n        ご利用プランを確認する\n      ")
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("h1", { staticClass: "payment-title" }, [
        _vm._v("プレミアムの登録をキャンセルしました")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-b-xl" }, [
      _vm._v("\n      お手続きありがとうございます。"),
      _c("br"),
      _vm._v(
        "\n      セラー様の操作によりプレミアムの登録手続きをキャンセルしました。"
      ),
      _c("br")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a41e90a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a41e90a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/setting/UpgradePlanCanceled.vue
// module id = null
// module chunks = 